import React from 'react';
import FormInput from './FormInput';
import SellerSelect from '../../SellerSelect';
import LocationSelect from '../../LocationSelect';

const PurchaseDetails = ({
  formData,
  handleChange,
  handleFocus,
  handleBlur,
  getDisplayValue,
  setFormData
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <div>
        <label htmlFor="storage_location" className="block text-sm font-medium text-gray-700 mb-2">
          Storage Location
        </label>
        <LocationSelect
          value={formData.storage_location || ''}
          onChange={handleChange}
          className="w-full"
        />
      </div>

      <div>
        <label htmlFor="purchase_date" className="block text-sm font-medium text-gray-700 mb-2">
          Purchase Date
        </label>
        <input
          type="date"
          name="purchase_date"
          id="purchase_date"
          value={formData.purchase_date}
          onChange={handleChange}
          className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
        />
      </div>

      <div>
        <label htmlFor="seller-search" className="block text-sm font-medium text-gray-700 mb-2">
          Seller
        </label>
        <SellerSelect
          value={formData.contact_id}
          onChange={(id) => setFormData(prev => ({ ...prev, contact_id: id }))}
          className="w-full"
        />
      </div>

      <FormInput
        label="Purchase Price"
        name="purchase_price"
        value={getDisplayValue('purchase_price', formData.purchase_price)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      <FormInput
        label="Grading Cost"
        name="grading_cost"
        value={getDisplayValue('grading_cost', formData.grading_cost)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      <FormInput
        label="Shipping Cost"
        name="shipping_cost"
        value={getDisplayValue('shipping_cost', formData.shipping_cost)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default PurchaseDetails;
